import m from "mithril";

export default () => {
    return {
        oninit: (v) => {},
        view: ({attrs: {state, actions}}) => {
            return null;
        },
    };
};

// import m from "mithril";
// import {Icons} from "../plugins/construct-ui";
// import tools from "../tools/tools";
// import pf from "../pf";
// import blockadmin from "./blockadmin";
// import blockview from "./block-view";
// import dbstore from "../db";

// export default () => {
//   const db = dbstore({
//     loadadmin: false,
//     key: Date.now(),
//   });

//   return {
//     oninit: ({attrs: {blockcode}}) => {
//       db.update({blockcode});
//     },
//     view: ({attrs: {blockcode, isadmin}}) => {
//       const block = db.states();
//       // console.log("current key", block.key);

//       if (block.loadadmin) {
//         return m(blockadmin, {block, update: db.update});
//       } else {
//         return m(
//           ".block-code-wrapper",
//           {
//             style: `display: grid; grid-template-rows: auto 1fr;`,
//           },
//           [
//             isadmin &&
//               m(
//                 ".admin-section",
//                 {
//                   style: `border: 1px solid lightgray;`,
//                 },
//                 [
//                   tools.Button("Edit", Icons.SETTINGS, undefined, () => {
//                     db.update({
//                       loading: true,
//                       loadadmin: true,
//                     });
//                   }),
//                 ]
//               ),
//             ,
//             [
//               m(blockview, {
//                 key: block.key,
//                 code: blockcode,
//                 onerror: (ex) => {
//                   pf.Inform("Cannot Render. Some issue", true);
//                   console.log("cannot render. here is the error", ex);
//                   db.update({
//                     loading: true,
//                     loadadmin: true,
//                   });
//                 },
//               }),
//             ],
//           ]
//         );
//       }
//     },
//   };
// };
